'use client';

import { createContext, ReactNode, useContext } from 'react';

import { useSearchFilters } from '@/hooks/use-search-filters';
import type { PostSearchParams, Sort } from '@/types/search';

type SearchParamsContextType = {
  filters: PostSearchParams;
  updateFilter: <K extends keyof PostSearchParams>(
    key: K,
    value: PostSearchParams[K],
  ) => void;
  applyFilters: () => void;
  clearFilters: () => void;
  removeFilter: (filterValue: string) => void;
  updateSort: (value: Sort) => void;
  isPending: boolean;
};

const SearchParamsContext = createContext<SearchParamsContextType | undefined>(
  undefined,
);

export function SearchParamsProvider({ children }: { children: ReactNode }) {
  const filtersState = useSearchFilters();

  return (
    <SearchParamsContext.Provider value={filtersState}>
      {children}
    </SearchParamsContext.Provider>
  );
}

export function useSearchParamsContext() {
  const context = useContext(SearchParamsContext);
  if (!context)
    throw new Error(
      'useSearchParamsContext must be used within a SearchParamsProvider',
    );
  return context;
}
